import React from 'react';
import AssessmentScoreResultContent from '../components/AssessmentScoreResultContent';

// 综合测评成绩查询页面
// 页面结构：条件筛选卡片 + 结果卡片（导出按钮 + 统计提示 + 成绩表格 + 详情抽屉）
export default function AssessmentScoreQueryPage() {
  return (
    <AssessmentScoreResultContent mode="query" />
  );
}
